<template>
  <v-row>
    <v-col>
      <v-col class="d-flex justify-space-between mx-auto flex-wrap container">
        <ToolbarTitles :title="title" />
        <ButtonsCardList @cardView="cardView" />
      </v-col>
      <div v-if="showCard" class="container">
        <CardsView
          :items="getComentarios"
          :openDialog="openDialog"
          @refreshItems="refreshItems"
          :showRefresh="true"
        />
      </div>
      <div v-if="!showCard" class="container">
        <TableWithSearch
          :items="getComentarios"
          :headers="allHeaders"
          :openDialog="openDialog"
          @headersUpdated="updateHeaders"
          @refreshItems="refreshItems"
          :showRefresh="true"
        />
      </div>
      <v-dialog
        v-model="open"
        max-width="500px"
        persistent
        @keydown.esc="reset()"
      >
        <FormOrder
          :allFields="parameters.items"
          @save="saveForm"
          @cancel="reset"
          :mode="mode"
        />
      </v-dialog>
      <DeleteDialog
        :showDialog="openDelete"
        :title="titleDelete"
        :confirmDelete="deleteItem"
        :cancelDelete="cancelDelete"
      />
      <Snackbar
        :alert="showSnackbar"
        :textAlert="textSnackbar"
        :color="colorSnackbar"
      />
    </v-col>
  </v-row>
</template>
<script>
import TableWithSearch from "@/components/Complement/TableWithSearch.vue";
import ToolbarTitles from "@/components/Complement/ToolbarTitles.vue";
import comentarios from "@/store/comentarios/comentarios.js";
import FormOrder from "@/components/Complement/FormOrder.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import configTable from "@/store/configuracionDeTablas/configTable.js";
import ButtonsCardList from "@/components/Complement/ButtonsCardList.vue";
import CardsView from "@/components/Complement/CardsView.vue";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";

export default {
  name: "Reports",
  components: {
    ToolbarTitles,
    TableWithSearch,
    FormOrder,
    Snackbar,
    ButtonsCardList,
    CardsView,
    DeleteDialog,
  },
  data() {
    return {
      titleTable: "comentariosAll",
      title: this.$tc("nav.comments"),
      mode: "",
      headers: [
        {
          text: "Comentario",
          value: "name",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Tipo",
          value: "subtitle",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "100px",
        },
      ],
      open: false,
      showSnackbar: false,
      textSnackbar: "",
      colorSnackbar: "",
      formValid: false,
      showCard: true,
      typeComment: [
        {
          text: "Auditoría",
          value: 1,
        },
        {
          text: "Autorización",
          value: 2,
        },
      ],
      itemOld: {},
      titleDelete: this.$tc("comentarios.deleteComments"),
      itemToDelete: null,
    };
  },
  mounted() {
    comentarios.dispatch("getComment");
    configTable.commit("setColums", []);
    let nameTable = this.titleTable;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (configTable.state.colums.length === 0 || configTable.state.colums.length !== this.headers.length ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
  },
  computed: {
    allHeaders() {
      return Array.isArray(configTable.state?.colums)
        ? configTable.state.colums
        : [];
    },
    getComentarios() {
      return comentarios.state.comment ? comentarios.state.comment : [];
    },
    parameters() {
      return {
        items: [
          {
            id: 1,
            show: true,
            data: "",
            name: "comentario",
            type: "text",
            label: this.$tc("comentarios.nameLabel"),
            items: [],
            itemText: "name",
            rules: [
              (v) =>
                (v !== null && v !== undefined && v !== "") ||
                this.$tc("editRegistrations.requerid"),
            ],
            order: 1,
          },
          {
            id: 2,
            show: true,
            data: "",
            name: "codAplica",
            type: "select",
            label: this.$tc("comentarios.TypeLabel"),
            items: this.typeComment,
            itemText: "text",
            itemValue: "value",
            rules: [
              (v) =>
                (v !== null && v !== undefined && v !== "") ||
                this.$tc("editRegistrations.requerid"),
            ],
            order: 2,
          },
        ],
      };
    },
    openDelete: {
      get() {
        return comentarios.state.openDelete;
      },
      set(newvalue) {
        return newvalue;
      },
    },
  },
  methods: {
    cardView(value) {
      this.showCard = value;
    },
    async refreshItems() {
      await comentarios.dispatch("getComment");
    },
    openDialog(type, item) {
      switch (type) {
        case "add":
          this.open = true;
          this.mode = this.$tc("comentarios.addComments");
          break;
        case "edit":
          this.open = true;
          this.mode = this.$tc("comentarios.editComment");
          this.itemOld = item;
          this.parameters.items[0].data = item.comentario;
          this.parameters.items[1].data = item.codAplica;
          break;
        case "delete":
          this.open = false;
          comentarios.commit("setOpenDelete", true);
          this.itemToDelete = item.comentId;
          break;
        default:
          break;
      }
    },

    updateHeaders(headers) {
      const updatedColums = headers;

      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = this.allHeaders;
      if (columnsToSave === undefined || this.allHeaders.length !== this.headers.length  || columnsToSave.length === 0) {
        columnsToSave = this.headers;
      }
      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };

      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    saveForm(item) {
      item.codAplica = parseInt(item.codAplica, 10);
      if (this.mode == this.$tc("comentarios.addComments")) {
        comentarios.commit("setNewComment", item);
        comentarios.dispatch("addComment").then(() => {
          this.alert(
            this.$tc("comentarios.addCommentSuccess"),
            "primary",
            true
          );
        });
      } else {
        let payload = {};
        if (this.itemOld.comentario !== item.comentario) {
          payload.comentario = item.comentario;
        }
        if (this.itemOld.codAplica !== item.codAplica) {
          payload.codAplica = item.codAplica;
        }
        if (Object.keys(payload).length !== 0) {
          payload.comentId = this.itemOld.comentId;
          comentarios.commit("setEdit", payload);
          comentarios.dispatch("edit").then(() => {
            this.alert(
              this.$tc("comentarios.editCommentSuccess"),
              "primary",
              true
            );
          });
        }
      }
      this.reset();
    },
    reset() {
      this.open = false;
      this.parameters.items[0].data = "";
      this.parameters.items[1].data = "";
    },
    alert(text, color, alert) {
      this.showSnackbar = alert;
      this.textSnackbar = text;
      this.colorSnackbar = color;
      setTimeout(() => {
        this.showSnackbar = false;
      }, 3000);
    },
    deleteItem() {
      comentarios.commit("setItemDelete", this.itemToDelete);
      comentarios
        .dispatch("delete")
        .then(() => {
          comentarios.commit("setOpenDelete", false);
          this.alert = true;
          this.textAlert = this.$tc("comentarios.deleteCommentAlert");
        })
        .catch((e) => {
          this.alert = true;
          this.textAlert = e.response.data.error.message;
          this.color = "#FF8D58";
        });
    },
    cancelDelete() {
      comentarios.commit("setOpenDelete", false);
    },
  },
};
</script>
<style scoped>
.container {
  max-width: 100%;
  padding-top: 1vh;
  padding-bottom: 1vh;
}
</style>
